import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EmpresaService } from '../../core/services/empresa.service';
import { ImagenService } from '../../core/services/imagen.service';
import { AlertService } from '../../core/services/alert.service';
import { PhotoGalleryEditorComponent, PhotoSlot } from '../../shared/components/photo-gallery-editor.component';
import { UiLoadingComponent } from '../../shared/components/ui-loading.component';

@Component({
    selector: 'app-admin-empresa',
    standalone: true,
    imports: [CommonModule, FormsModule, PhotoGalleryEditorComponent, UiLoadingComponent],
    template: `
    <div class="mb-6">
      <h2 class="text-2xl font-black text-gray-800">Datos de la empresa</h2>
      <p class="text-sm text-gray-400 mt-1">Logo, facturación, envío y mensaje de tarjeta.</p>
    </div>

    <app-ui-loading *ngIf="loading()"></app-ui-loading>

    <form *ngIf="!loading()" class="grid grid-cols-1 lg:grid-cols-12 gap-6" (ngSubmit)="guardar()">
      <section class="lg:col-span-4 bg-white rounded-[2rem] p-6 border border-rose-100 shadow-sm h-fit">
        <app-photo-gallery-editor
          [photos]="logo()"
          (photosChange)="logo.set($event)"
          [multiple]="false"
          title="Logo"
          hint="Se muestra en la tienda. Se sube al guardar.">
        </app-photo-gallery-editor>
      </section>

      <section class="lg:col-span-8 bg-white rounded-[2rem] p-6 border border-rose-100 shadow-sm grid grid-cols-1 md:grid-cols-2 gap-4">
        <p class="md:col-span-2 text-[11px] font-black uppercase tracking-widest text-rose-400 pt-1">Datos fiscales</p>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">RUC</span>
          <input [ngModel]="ruc()" (ngModelChange)="ruc.set($event)" name="ruc" required class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Nombre comercial</span>
          <input [ngModel]="nombreComercial()" (ngModelChange)="nombreComercial.set($event)" name="nombreComercial" required class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="md:col-span-2 block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Razón social</span>
          <input [ngModel]="razonSocial()" (ngModelChange)="razonSocial.set($event)" name="razonSocial" required class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <p class="md:col-span-2 text-[11px] font-black uppercase tracking-widest text-rose-400 pt-2">Contacto y ubicación</p>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Dirección</span>
          <input [ngModel]="direccion()" (ngModelChange)="direccion.set($event)" name="direccion" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Distrito</span>
          <input [ngModel]="distrito()" (ngModelChange)="distrito.set($event)" name="distrito" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Teléfono</span>
          <input [ngModel]="telefono()" (ngModelChange)="telefono.set($event)" name="telefono" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">WhatsApp</span>
          <input [ngModel]="whatsapp()" (ngModelChange)="whatsapp.set($event)" name="whatsapp" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="md:col-span-2 block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Correo</span>
          <input [ngModel]="correo()" (ngModelChange)="correo.set($event)" name="correo" type="email" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <p class="md:col-span-2 text-[11px] font-black uppercase tracking-widest text-rose-400 pt-2">Redes sociales</p>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Facebook</span>
          <input [ngModel]="facebookUrl()" (ngModelChange)="facebookUrl.set($event)" name="facebookUrl" placeholder="https://facebook.com/…" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Instagram</span>
          <input [ngModel]="instagramUrl()" (ngModelChange)="instagramUrl.set($event)" name="instagramUrl" placeholder="https://instagram.com/…" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">TikTok</span>
          <input [ngModel]="tiktokUrl()" (ngModelChange)="tiktokUrl.set($event)" name="tiktokUrl" placeholder="https://tiktok.com/@…" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">YouTube</span>
          <input [ngModel]="youtubeUrl()" (ngModelChange)="youtubeUrl.set($event)" name="youtubeUrl" placeholder="https://youtube.com/@…" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
        </label>
        <label class="md:col-span-2 block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Twitter / X</span>
          <input [ngModel]="twitterUrl()" (ngModelChange)="twitterUrl.set($event)" name="twitterUrl" placeholder="https://x.com/…" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
          <span class="text-[11px] text-gray-400">Solo se muestran en el footer las redes que completes.</span>
        </label>

        <p class="md:col-span-2 text-[11px] font-black uppercase tracking-widest text-rose-400 pt-2">Checkout y reservas</p>
        <label class="block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Reserva (minutos)</span>
          <input [ngModel]="reserva()" (ngModelChange)="reserva.set($event)" name="reserva" type="number" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
          <span class="text-[11px] text-gray-400">Tiempo que el cliente tiene para pagar antes de liberar su reserva (ej: 10).</span>
        </label>
        <label class="md:col-span-2 block">
          <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Máx. caracteres del mensaje de tarjeta</span>
          <input [ngModel]="maxTarjeta()" (ngModelChange)="maxTarjeta.set($event)" name="maxTarjeta" type="number" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
          <p class="text-xs text-gray-400 mt-1">El mensaje en el checkout es opcional, pero este límite sí se usa.</p>
        </label>
        <button [disabled]="saving()" class="md:col-span-2 py-3.5 rounded-2xl text-white font-bold text-sm disabled:opacity-60" style="background-color: var(--bg-main);">
          {{ saving() ? 'Guardando...' : 'Guardar empresa' }}
        </button>
      </section>
    </form>
    `
})
export class AdminEmpresaComponent implements OnInit {
    private empresaService = inject(EmpresaService);
    private imagenService = inject(ImagenService);
    private alerts = inject(AlertService);

    loading = signal(true);
    saving = signal(false);
    logo = signal<PhotoSlot[]>([]);
    logoUuid = signal<string | null>(null);
    ruc = signal('');
    razonSocial = signal('');
    nombreComercial = signal('');
    direccion = signal('');
    distrito = signal('');
    telefono = signal('');
    whatsapp = signal('');
    facebookUrl = signal('');
    instagramUrl = signal('');
    tiktokUrl = signal('');
    youtubeUrl = signal('');
    twitterUrl = signal('');
    correo = signal('');
    reserva = signal(60);
    maxTarjeta = signal(400);
    tipoCambio = signal(3.7);

    ngOnInit(): void {
        this.empresaService.invalidate();
        this.empresaService.getEmpresa().subscribe({
            next: (e) => {
                if (e) {
                    this.ruc.set(e.ruc);
                    this.razonSocial.set(e.razonSocial);
                    this.nombreComercial.set(e.nombreComercial);
                    this.direccion.set(e.direccion ?? '');
                    this.distrito.set(e.distrito ?? '');
                    this.telefono.set(e.telefono ?? '');
                    this.whatsapp.set(e.whatsapp ?? '');
                    this.facebookUrl.set(e.facebookUrl ?? '');
                    this.instagramUrl.set(e.instagramUrl ?? '');
                    this.tiktokUrl.set(e.tiktokUrl ?? '');
                    this.youtubeUrl.set(e.youtubeUrl ?? '');
                    this.twitterUrl.set(e.twitterUrl ?? '');
                    this.correo.set(e.correo ?? '');
                    this.reserva.set(e.tiempoReservaMinutos);
                    this.maxTarjeta.set(e.maxCaracteresTarjeta);
                    this.tipoCambio.set(e.tipoCambioUsd);
                    this.logoUuid.set(e.imagenLogoUuid);
                    this.logo.set(e.urlLogo ? [{ previewUrl: e.urlLogo, imagenUuid: e.imagenLogoUuid, file: null }] : []);
                }
                this.loading.set(false);
            },
            error: () => {
                this.loading.set(false);
                this.alerts.error('No se pudo cargar la empresa.');
            }
        });
    }

    guardar() {
        this.saving.set(true);
        const pending = this.logo().filter((f) => !!f.file).map((f) => f.file as File);
        if (pending.length) {
            this.imagenService.upload(pending).subscribe({
                next: (imgs) => this.enviar(imgs[0]?.uuid ?? this.logoUuid()),
                error: (err) => {
                    this.saving.set(false);
                    this.alerts.error(err?.message || 'No se pudo subir el logo');
                }
            });
            return;
        }
        this.enviar(this.logo()[0]?.imagenUuid ?? null);
    }

    private enviar(imagenLogoUuid: string | null) {
        this.empresaService.updateEmpresa({
            ruc: this.ruc(),
            razonSocial: this.razonSocial(),
            nombreComercial: this.nombreComercial(),
            direccion: this.direccion(),
            distrito: this.distrito(),
            telefono: this.telefono(),
            whatsapp: this.whatsapp(),
            facebookUrl: this.facebookUrl(),
            instagramUrl: this.instagramUrl(),
            tiktokUrl: this.tiktokUrl(),
            youtubeUrl: this.youtubeUrl(),
            twitterUrl: this.twitterUrl(),
            correo: this.correo(),
            imagenLogoUuid,
            tipoCambioUsd: this.tipoCambio(),
            tiempoReservaMinutos: Number(this.reserva()),
            maxCaracteresTarjeta: Number(this.maxTarjeta())
        }).subscribe({
            next: (ok) => {
                this.saving.set(false);
                ok ? this.alerts.ok('Empresa actualizada') : this.alerts.error('No se pudo guardar');
            },
            error: () => {
                this.saving.set(false);
                this.alerts.error('No se pudo guardar');
            }
        });
    }
}
